// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3JNbp","head":"Table_head__2LjBN","col":"Table_col__taAJz"};